import useFetch from 'utils/hooks/useFetch'
import { ApiGetDailyTransaction } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function DailyTransactionService() {
    const { showFail } = useModal()

    const { fetch: apiGetDailyTransactionList } = useFetch(ApiGetDailyTransaction)
 
    const fetchDailyTransactionList = async (dateFrom, dateTo, showCustomerExeption, edcId, groupBy) => {
        const res = await apiGetDailyTransactionList({
            data: {
                dateFrom,
                dateTo,
                showCustomerExeption,
                edcId,
                groupBy
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchDailyTransactionList
    }
}